import styled from "styled-components";

export const StyledNavbar = styled.div `
    display: flex;
    justify-content: space-between;
`;